import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pac-solicitud-aprobar',
  templateUrl: './pac-solicitud-aprobar.component.html',  
  styleUrls: []
})
export class PacSolicitudAprobarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
